import { SybaseTableDataset } from 'app/model/dataset/sybase-table.dataset';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sybase.copySourceType,
    display: [],
    tags: {
        datasetModel: Metamodel.modelFor(SybaseTableDataset)
    }
})
export class SybaseCopySource extends TabularCopySource {
}
